import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { BookmarkApiData } from '../../../components/bookmark/lib/entities';
import { useBookmark } from '../../../context';
import { ResourcePath } from '../../../hooks/resource-path';
import { QueryKey } from '../../../lib/query-key';

export interface UseDeleteBookmarkProps {
	options: UseMutationOptions;
	id?: string;
}
export const useDeleteBookmark = ({ options, id }: UseDeleteBookmarkProps) => {
	const http = useHttpClient('v2');
	const { setBookmark } = useBookmark();
	const queryClient = useQueryClient();

	return useMutation(() => http.delete<BookmarkApiData>(`${ResourcePath.Bookmarks}/${id}`), {
		...options,
		onSuccess: (data, variables, context) => {
			setBookmark(undefined);
			queryClient.invalidateQueries([QueryKey.Bookmarks, '']);
			queryClient.invalidateQueries([QueryKey.Labels]);

			options.onSuccess?.(data, variables, context);
		},
	});
};
